import { SortedTimeBucketOptions, TimeBucketSet } from '@fabric-ui/components/Table';
import Pluralize from 'pluralize';
import { Field } from '../../../types';

export const hasTimeBucket = (value: string) => TimeBucketSet.has(value);

export const getSelectedBreakdownsTitle = (dims: Array<{ name: string }>) =>
  dims
    .filter(({ name }) => hasTimeBucket(name))
    .map(({ name }) => SortedTimeBucketOptions.find(option => option.value === name)?.label)
    .filter((label): label is string => Boolean(label))
    .map(label => Pluralize(label).toUpperCase())
    .join(', ');

export const filterTimeBucketFromDimensions = (dims: Field[]) => dims.filter(({ name }) => !hasTimeBucket(name));
